export default "__VITE_ASSET__BfnPRus8__"